import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ERROR_HANDLING_TRANSLATIONS, ErrorServiceTranslations } from './providers';

const messages: ErrorServiceTranslations = {
  error: 'Error',
  knownErrorKey: 'oca.error',
  unknownError: 'Unknown error',
  retry: 'Retry',
  close: 'Close',
};

export const provideErrorHandlingTranslations = (translationKeys: ErrorServiceTranslations = messages): EnvironmentProviders => (
  makeEnvironmentProviders([{ provide: ERROR_HANDLING_TRANSLATIONS, useValue: translationKeys }])
);
